import React, { useEffect, useState } from "react";
import { Doughnut, Bar } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from "chart.js";

// Register the required components for both Doughnut and Bar charts
ChartJS.register(ArcElement, Tooltip, Legend, BarElement, CategoryScale, LinearScale);

const backendUrl = process.env.REACT_APP_BACKEND_API_URL_LOCAL;

const doughnutPalette = ["#FF6384", "#36A2EB", "#FFCE56", "#FF9F40", "#4BC0C0", "#9966FF", "#C9CBCF"];
const barPalette = ["#FF9AA2", "#FFDAC1", "#E2F0CB", "#B5EAD7", "#C7CEEA", "#FFC3A0"];

const capitalize = (value) => (value ? value.charAt(0).toUpperCase() + value.slice(1) : value);

const Mapfun = () => {
  const [motorizedPairs, setMotorizedPairs] = useState([]);
  const [motorizedToOthers, setMotorizedToOthers] = useState([]);

  useEffect(() => {
    fetch(`${backendUrl}roadaccident/vehicle_accident_stats/`)
      .then((response) => response.json())
      .then((data) => {
        setMotorizedPairs(data.motorized_pairs || []);
        setMotorizedToOthers(data.motorized_to_others || []);
      })
      .catch((error) => console.error("Error loading vehicle accident stats:", error));
  }, []);

  const data1 = {
    labels: motorizedPairs.map(
      (item) => `${capitalize(item.motorized_vehicle1)}-${capitalize(item.motorized_vehicle2)}`
    ),
    datasets: [
      {
        label: "Accidents",
        data: motorizedPairs.map((item) => item.count),
        backgroundColor: motorizedPairs.map((_, index) => doughnutPalette[index % doughnutPalette.length]),
        hoverOffset: 10, // Increased for a more pronounced hover effect
      },
    ],
  };

  const data2 = {
    labels: motorizedToOthers.map(
      (item) => `${capitalize(item.motorized_vehicle)}-${capitalize(item.others)}`
    ),
    datasets: [
      {
        label: "Accidents",
        data: motorizedToOthers.map((item) => item.count),
        backgroundColor: motorizedToOthers.map((_, index) => barPalette[index % barPalette.length]),
        borderWidth: 1,
        borderColor: "#fff",
      },
    ],
  };

  // Common options for both charts
  const baseOptions = {
    responsive: true,
    maintainAspectRatio: false, // Allows better control over height
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "",
      },
    },
  };

  // Specific options for Doughnut chart
  const doughnutOptions = {
    ...baseOptions,
    cutout: "60%", // Controls the size of the hole in the Doughnut
    plugins: {
      ...baseOptions.plugins,
      title: {
        display: true,
        text: "Accidents Reported Between Motorized Vehicles",
      },
    },
  };

  // Specific options for Bar chart
  const barOptions = {
    ...baseOptions,
    plugins: {
      ...baseOptions.plugins,
      title: {
        display: true,
        text: "Accidents Reported Between Motorized to Others",
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: "Number of Accidents",
        },
      },
      x: {
        title: {
          display: true,
          text: "Accident Type",
        },
      },
    },
  };

  return (
    <div className="main-container">
      <div style={styles.container}>
        <div style={styles.chartBox}>
          <h3 style={styles.chartTitle}>
            Accidents Reported Between Motorized Vehicles
          </h3>
          <div style={styles.chartContainer}>
            <Doughnut data={data1} options={doughnutOptions} />
          </div>
        </div>
        <div style={styles.chartBox}>
          <h3 style={styles.chartTitle}>
            Accidents Reported Between Motorized to Others
          </h3>
          <div style={styles.chartContainer}>
            <Bar data={data2} options={barOptions} />
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    padding: "2px",
    gap: "8px",
    width: "100%",
  },
  chartBox: {
    flex: "0 1 50%", // Ensures the boxes take up 50% of the container each
    border: "1px solid #ccc",
    padding: "20px",
    maxWidth: "100%", // Optional: Set max width for consistent sizing
  },
  chartTitle: {
    textAlign: "center",
    marginBottom: "20px",
    fontSize: "18px",
    fontWeight: "bold",
  },
  chartContainer: {
    height: "400px", // Fixed height for consistency
  },
};

export default Mapfun;